import axios from 'axios'

const state = {
  payment_methods: {},
  payment_methods_plans: {},
  payment_sub_methods: {}
}

const getters = {
  getMethods(state) {
    return state.payment_methods
  },
  getMethodsForPlans(state) {
    return state.payment_methods_plans
  },
  getSubMethods(state) {
    return state.payment_sub_methods
  },
  getPaymentsData(state) {
    return state
  }
}

const mutations = {
  setMethods(state, data) {
    state.payment_methods = data
  },
  setMethodsPlans(state, data) {
    state.payment_methods_plans = data
  },
  setSubMethods(state, data) {
    state.payment_sub_methods = data
  },
  setPaymentsData(state, data) {
    state
  }
}

const actions = {
  getMethods({ commit, dispatch, state }, data) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'get',
        url: '/api/payment/methods',
        data: data
      })
        .then(response => {
          commit('setMethods', response.data)
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getPaymentMethodsSubTypes({ commit, dispatch, state }, data) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'post',
        url: '/paysera/sub-methods',
        data: { type_id: data.type_id, country_code: data.country_code }
      })
        .then(response => {
          commit('setSubMethods', response.data)
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
